import { InputBase, Divider } from '@material-ui/core';
import CallIcon from '@material-ui/icons/Call';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
  background-color: ${colors.white};
`;

export const PaperContainer = lib.styled.div`
  padding: 2px 0px 0px 10px;
  display: flex;
  align-items: center;
  height: 60px;
  background-color: ${colors.lightGray07};

  .icon {
    width: 50px;
    height: 50px;
    padding: 0px;
    margin-right: 5px;
  }
`;

export const InputBaseContainer = lib.styled(InputBase)`
  margin-left: 8px;
  flex: 1;

  input {
    font-weight: bold;
    font-size: 20px;

    &::placeholder {
      font-weight: normal;
      font-size: 15px;
    }
  }
`;

export const DividerContainer = lib.styled(Divider)`
  width: 1px;
  height: 28px!important;
  margin: 4px;
`;

export const CallIconContainer = lib.styled(CallIcon)`
  color: ${colors.greenNormal};
`;
export const LoaderView = lib.styled.div`
  display: flex;
  margin-left: 10px;
  margin-right: 10px;

  .MuiCircularProgress-colorPrimary {
    color: ${colors.black};
    opacity: 0.6;
  }
`;
